"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetGiveaways200ResponseToJSON = exports.GetGiveaways200ResponseFromJSONTyped = exports.GetGiveaways200ResponseFromJSON = exports.instanceOfGetGiveaways200Response = void 0;
var GetGiveaways200ResponseData_1 = require("./GetGiveaways200ResponseData");
/**
 * Check if a given object implements the GetGiveaways200Response interface.
 */
function instanceOfGetGiveaways200Response(value) {
    var isInstance = true;
    isInstance = isInstance && "data" in value;
    return isInstance;
}
exports.instanceOfGetGiveaways200Response = instanceOfGetGiveaways200Response;
function GetGiveaways200ResponseFromJSON(json) {
    return GetGiveaways200ResponseFromJSONTyped(json, false);
}
exports.GetGiveaways200ResponseFromJSON = GetGiveaways200ResponseFromJSON;
function GetGiveaways200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'data': (0, GetGiveaways200ResponseData_1.GetGiveaways200ResponseDataFromJSON)(json['data']),
    };
}
exports.GetGiveaways200ResponseFromJSONTyped = GetGiveaways200ResponseFromJSONTyped;
function GetGiveaways200ResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'data': (0, GetGiveaways200ResponseData_1.GetGiveaways200ResponseDataToJSON)(value.data),
    };
}
exports.GetGiveaways200ResponseToJSON = GetGiveaways200ResponseToJSON;
